import React, { useState, useEffect } from "react";
import classNames from "classnames";
import disableScroll from "disable-scroll";
import { CSSTransition } from "react-transition-group";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

const DefaultContainer = ({ children, props }) => {
  const { closeModal, getIsAboutToClose } = useModal();
  const { getDirection } = useContent();

  const modalClassNames = classNames(["modal-overlay", getDirection()]);
  const [animation, setAnimation] = useState();

  useEffect(() => {
    setAnimation(true);
    document.body.classList.add("stop-scroll");
    disableScroll.options = {
      disableWheel: false,
      disableScroll: true,
      disableKeys: false,
      keyboardKeys: [32, 33, 34, 35, 36, 37, 38, 39, 40],
    };
    // disableScroll.on();
    return () => {
      document.body.classList.remove("stop-scroll");
      disableScroll.off();
    };
  }, []);

  return (
    <CSSTransition
      in={!!animation && !getIsAboutToClose()}
      classNames={"modal"}
      timeout={500}
      unmountOnExit={true}
    >
      <div className={modalClassNames + " jumbopay-process"}>
        <div className="modal">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {children}
          </div>
          <div className="modal-close-button">
            <Icon large name="x" gray onClick={closeModal} />
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default DefaultContainer;
